export enum OrderBookType {
  Each = 'Each',
  Stack = 'Stack',
}

export enum BookLayoutMode {
  DEFAULT = 'DEFAULT',
  BUY = 'BUY',
  SELL = 'SELL',
}
